import { useQuery } from '@tanstack/react-query';
import { itemsApi } from '../api/items';

export function usePages(itemId: string) {
  return useQuery({
    queryKey: ['pages', itemId],
    queryFn: () => itemsApi.getPages(itemId),
    staleTime: 30 * 60 * 1000, // 30分（1時間有効期限のバッファ）
    gcTime: 60 * 60 * 1000, // 1時間
    refetchOnMount: 'always', // 新鮮なPresigned URLを保証
  });
}
